import {Component} from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"

import BlockNavigationActions from "../utils/store/actions"

export {default as BlockNavigationReducer} from "../utils/store/reducer"
export {default as BlockNavigationActions} from "../utils/store/actions"

class Blocker extends Component {
  static propTypes = {
    showMsg: PropTypes.bool,
    unblock: PropTypes.func.isRequired,
    component: PropTypes.element,
    msg: PropTypes.string
  }

  static defaultProps = {
    component: null,
    msg: null,
    showMsg: null
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {component, showMsg} = this.props

    if (!showMsg) {
      return null
    }

    return component
  }

  componentDidUpdate() {
    const {component, msg, unblock, showMsg} = this.props
    if (showMsg && !component) {
      const navAway = confirm(msg)
      unblock(navAway)
      return null
    }
  }
}

const mapStateToProps = ({blockNavigation}) => {
  return {
    component: blockNavigation.component,
    msg: blockNavigation.msg,
    showMsg: blockNavigation.show
  }
}

const actions = (dispatch) => {
  return {
    unblock: (shouldUnblock) => dispatch(BlockNavigationActions.unblock(shouldUnblock))
  }
}

export default connect(mapStateToProps, actions)(Blocker)
